class ProductsDisplay extends HTMLElement {
  static get observedAttributes() {
    return ["data-active-tab"];
  }

  connectedCallback() {
    this.initializeTabs();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-active-tab" && oldValue !== newValue) {
      this.updateTabDisplay(newValue);
    }
  }

  initializeTabs() {
    this.tabButtons = this.querySelectorAll(".product-display__toggle");
    this.tabContents = this.querySelectorAll(
      '[id^="product-display-content-"]'
    );

    this.tabButtons.forEach((button) => {
      button.addEventListener("click", this.handleTabClick.bind(this));
    });

    const firstTab = this.tabButtons[0];
    if (firstTab) {
      this.setActiveTab(firstTab.id);
    }
  }

  removeEventListeners() {
    if (this.tabButtons) {
      this.tabButtons.forEach((button) => {
        button.removeEventListener("click", this.handleTabClick.bind(this));
      });
    }
  }

  handleTabClick(event) {
    const tabId = event.currentTarget.id;
    this.setActiveTab(tabId);
  }

  setActiveTab(tabId) {
    this.setAttribute("data-active-tab", tabId);
  }

  updateTabDisplay(activeTabId) {
    this.tabButtons.forEach((button) => {
      const isActive = button.id === activeTabId;
      button.setAttribute("aria-selected", isActive);
      button.classList.toggle("active", isActive);
    });

    this.tabContents.forEach((content) => {
      const correspondingTabId = content.getAttribute("aria-labelledby");
      const isVisible = correspondingTabId === activeTabId;
      content.setAttribute("aria-hidden", !isVisible);
    });
  }
}

customElements.define("products-display", ProductsDisplay);
